/* src/app/user-access-history/user-access-history-search/user-access-history-search.component.scss */
.search.icon:before {
  font-family: upsicons, fantasy !important;
  content: "\e668" !important;
  color: #FFF;
}
.clear.icon:before {
  font-family: upsicons, fantasy !important;
  content: "\e67b" !important;
  color: #FFF;
}
label {
  margin-bottom: 5px;
}
/*# sourceMappingURL=user-access-history-search.component.css.map */
